export const youTubeAlreadyAllowListed = "yt-site.already.allowlisted";
export const youTubeAutoAllowlisted = "yt-auto.allowlisted";
export const youTubeWallDetected = "yt-site.ad-wall-detected";
export const youTubeNavigation = "yt-site.navigation";
export const adShownEvent = "yt-site.ad-shown";
export const toastShownEvent = "yt-site.toast-shown";
export const contextTamperingEvent = "yt-site.context-tampering";
export const errorEvent = "yt-site.yt-error";
export var ErrorType;
(function (ErrorType) {
    ErrorType["PLAYER_ERROR"] = "player_error";
    ErrorType["UNCAUGHT_EXCEPTION"] = "uncaught_exception";
    ErrorType["SWW_ERROR"] = "sww_error";
})(ErrorType || (ErrorType = {}));
export const ytRecordEvent = "yt-site.record-event";
